import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { AlertService } from   '@app/core/services/alert.service';
import { Alert, AlertType, AlertMethod } from '@app/core/models/alert.model';

@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './alert.html',
  styleUrl: './alert.scss'
})
export class AlertComponent implements OnInit, OnDestroy {
  alerts: Alert[] = [];
  private subscription: Subscription = new Subscription();

  constructor(@Inject(AlertService) private alertService: AlertService) {}

  ngOnInit(): void {
    this.subscription = this.alertService.alerts$.subscribe((alerts: Alert[]) => {
      this.alerts = alerts;
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  dismissAlert(alertId: string): void {
    this.alertService.removeAlert(alertId);
  }

  executeAction(action: () => void): void {
    action();
  }

  getAlertIconClass(alert: Alert): string {
    switch (alert.type) {
      case AlertType.SUCCESS:
        return 'alert-icon-success';
      case AlertType.WARNING:
        return 'alert-icon-warning';
      case AlertType.ERROR:
        return 'alert-icon-error';
      case AlertType.HINT:
        return 'alert-icon-hint';
      default:
        return '';
    }
  }

  getAlertClass(alert: Alert): string {
    const baseClass = 'alert';
    const typeClass = `alert-${alert.type}`;
    const methodClass = `alert-${alert.method}`;
    return `${baseClass} ${typeClass} ${methodClass}`;
  }
}
